import _find from 'lodash/find';
import _omitBy from 'lodash/omitBy';
import _isNil from 'lodash/isNil';
import _forEach from 'lodash/forEach';
import _set from 'lodash/set';
import { ILiveBlogCard } from '../types/component-type';
import { getCardHeaderHeadlineElement, getCardHeaderDescriptionElement } from './card';
import StoryMetadata from '../types/metadata';
import { getHtmlText } from '../../../utils/string-helper';
import { getArcPhotoImageProxy } from '../../../shared/photo-center/photo-url-helper';

export const getThumbnailImageUrl = (photo) => {
  return getArcPhotoImageProxy(photo, 'thumbnail');
}

export const getArcComposerUrl = (articleId) => `https://${ process.env.REACT_APP_PROJECT_ENV !== "prod" ? "sandbox." : "" }pmn.arcpublishing.com/composer/story/v2/edit/${articleId}/`;

export const END_LIVEBLOG_TAG = {
  description: "endliveblog",
  slug: "endliveblog",
  text: "endliveblog"
};

export const hasEndLiveblogTag = (article) => article?.taxonomy?.tags?.some((tag) => tag?.slug === END_LIVEBLOG_TAG.slug || tag?.label === END_LIVEBLOG_TAG.slug);

export const getTimeStampItem = (data: ILiveBlogCard) => (
  _find(data?.elements || [], element => (typeof element?.content === 'string' ?  element?.content : '')?.includes('// Timestamp'))
)

export const getPinnedItem = (data: ILiveBlogCard) => (
  _find(data?.elements || [], element => (typeof element?.content === 'string' ?  element?.content : '')?.includes('// Pinned'))
)

export const getImageSrc = (imageData: IArticleContentElement): string => {
  return getArcPhotoImageProxy(imageData);
};


export const getUpdatedHeaderDetails = (workingArticle, workingCard, isNestedObject, fullContent) => {
  const basicHeadlineElement = getCardHeaderHeadlineElement(workingCard?.elements, workingArticle?._id);
  const basicDescriptionElement = getCardHeaderDescriptionElement(workingCard?.elements,  workingArticle?._id);
  const featuredImageElement = _find(workingCard?.elements, (element) => element?.referent?.type === 'image');

  const updatedHeader = _omitBy({
    'headlines.basic': getHtmlText(basicHeadlineElement?.content) ?? '',
    'description.basic': getHtmlText(basicDescriptionElement?.content) ?? '',
    'promo_items.basic': featuredImageElement?.referent ?? fullContent?.promo_items?.basic,
    'promo_items.promo': workingArticle?.promo_items?.promo,
    'label.commission_team_2': workingArticle?.[StoryMetadata.Team2] ?? fullContent?.label?.commission_team_2,
    'slug': workingArticle?.[StoryMetadata.Slug] ?? fullContent?.slug,
    'credits.by': workingArticle?.[StoryMetadata.Credits] ?? fullContent?.credits?.by,
    'label.commission_team_1_required': workingArticle?.[StoryMetadata.Team1] ?? fullContent?.label?.commission_team_1_required,
    'headlines.meta_title': workingArticle?.[StoryMetadata.HeadlinesMetaTitle] ?? fullContent?.headlines?.meta_title,
    'headlines.web': workingArticle?.[StoryMetadata.HeadlinesWeb] ?? fullContent?.headlines?.web,
    'taxonomy.seo_keywords': workingArticle?.taxonomy?.seo_keywords ?? workingArticle?.[StoryMetadata.SeoKeywords] ?? fullContent?.taxonomy?.seo_keywords,
    'taxonomy.tags': workingArticle?.[StoryMetadata.Tags] ?? fullContent?.taxonomy?.tags,
    'taxonomy.sections': workingArticle?.taxonomy?.sections ?? null,
    'taxonomy.primary_section': workingArticle?.taxonomy?.primary_section ?? null,
    'taxonomy.primary_site': workingArticle?.taxonomy?.primary_site ?? null,
  }, _isNil);

  if (!isNestedObject) return updatedHeader;

  const nestedObject = {};

  _forEach(updatedHeader, (value, key) => {
    _set(nestedObject, key, value);
  });

  return nestedObject;
};

export const getTimeLines = (contentElements) => 
  contentElements
    .map((element, key) => {
      const currentType = element?.type || '';
      const nextElement = contentElements[key + 1];

      if (currentType === 'header' && nextElement?.type === 'text') {
        return {
          timeline_content: element?.content || '',
        };
      }

      return null;
    })
    .filter(Boolean);
